import Guid from "common/values/guid/guid";
import Subscriber from "messaging/values/subcriber/subscriber";
import Topic from "messaging/values/topic";
import { Moment } from "moment";


export default class Forum {
  id?: Guid;
  name?: string;
  topic?: Topic;
  subscribers: Subscriber[];
  creator?: Subscriber;
  createdDate?: Moment;
  isResolved?: boolean;
  numUnreadMessages?: number;

  constructor(
    name?: string,
    topic?: Topic,
    subscribers: Subscriber[] = [],
    id?: Guid,
    creator?: Subscriber,
    createdDate?: Moment,
    numUnreadMessages?: number
  ) {
    this.id = id;
    this.name = name;
    this.topic = topic;
    this.subscribers = subscribers;
    if (creator) {
      this.creator = creator;
    }
    if (createdDate) {
      this.createdDate = createdDate;
    }
    this.numUnreadMessages = numUnreadMessages ?? 0;
  }
}

export class ForumDoesNotExistError extends Error {
  constructor(id?: Guid | string) {
    if (id instanceof Guid) {
      super(`Forum ${id} does not exist`);
    } else {
      super(`Forum does not exist: ${id}`);
    }
  }
}

export class UnauthorizedForumAccessException extends Error {
  constructor(forumId: Guid) {
    super(`User is not authorized to access forum ${forumId}`);
  }
}
